import { render, staticRenderFns } from "./AssignationTransaction.vue?vue&type=template&id=7908e124&"
import script from "./AssignationTransaction.vue?vue&type=script&lang=js&"
export * from "./AssignationTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports